import React, { lazy } from 'react';

const DownPaymentComponent = lazy(
  () =>
    import(
      /* webpackChunkName: "carvana-purchase-payment-collection" */ '|/app/purchase/checkout/steps/down-payment'
    )
);

export const DownPaymentRoute = () => {
  return <DownPaymentComponent />;
};
